/* Lasani theme scripts */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const routes = window.LasaniRoutes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = window.LasaniMoney || 'Rs.{{amount}}';
    const value = (cents / 100);
    const withDelims = (n, d) => n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0);
        case 'amount_with_comma_separator': return withDelims(value, 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0).replace(/,/g, '.');
        default: return withDelims(value, 2);
      }
    });
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Drawers (menu + cart) ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusTarget = el.querySelector('[tabindex="-1"], button, a');
    if (focusTarget) setTimeout(() => focusTarget.focus(), 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .menu-drawer.is-open').forEach(closeDrawer);
    const sp = $('[data-search-panel]');
    if (sp && !sp.hidden) toggleSearch(false);
  });

  const menuDrawer = $('[data-menu-drawer]');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => {
    openDrawer(menuDrawer);
    b.setAttribute('aria-expanded', 'true');
  }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => {
    closeDrawer(menuDrawer);
    $$('[data-menu-open]').forEach((x) => x.setAttribute('aria-expanded', 'false'));
  }));

  /* ---------- Announcement rotation ---------- */
  $$('[data-announce]').forEach((bar) => {
    const items = $$('.announce__item', bar);
    if (items.length < 2 || reduceMotion) return;
    let i = 0;
    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Header scroll state ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Search panel + predictive search ---------- */
  const searchPanel = $('[data-search-panel]');
  function toggleSearch(show) {
    if (!searchPanel) return;
    searchPanel.hidden = !show;
    if (show) $('input[type="search"]', searchPanel).focus();
  }
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => toggleSearch(searchPanel.hidden)));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => toggleSearch(false)));

  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  if (pInput && pResults) {
    let timer;
    pInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const res = await fetch(`${routes.root.replace(/\/$/, '')}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const data = await res.json();
          const products = (data.resources && data.resources.results.products) || [];
          if (!products.length) {
            pResults.innerHTML = `<p class="muted">No styles match "${esc(q)}". Press enter to search everything.</p>`;
            return;
          }
          pResults.innerHTML = `<div class="predictive">${products.map((p) => `
            <a href="${p.url}">
              ${p.image ? `<img src="${p.image}" alt="" loading="lazy" width="56" height="70">` : ''}
              <span><strong>${esc(p.title)}</strong><span class="muted">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span>
            </a>`).join('')}</div>`;
        } catch (e) { pResults.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Sliders ---------- */
  function bindSlider(scope) {
    const track = $('[data-slider]', scope);
    if (!track) return;
    const controls = $('.slider-controls', scope);
    const sync = () => { if (controls) controls.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 4); };
    sync();
    window.addEventListener('resize', sync, { passive: true });
    $$('[data-slide]', scope).forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.slide === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }
  $$('.section').forEach(bindSlider);

  /* ---------- Cart ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const useDrawer = document.body.dataset.cartType === 'drawer' && cartDrawer;

  async function getCart() {
    const res = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-cart-open]').forEach((el) => el.setAttribute('aria-label', `Cart, ${count} items`));
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!cartDrawer) return;
    const items = $('[data-cart-items]', cartDrawer);
    const empty = $('[data-cart-empty]', cartDrawer);
    const foot = $('[data-cart-foot]', cartDrawer);
    const label = $('[data-cart-count-label]', cartDrawer);
    label.textContent = cart.item_count ? `(${cart.item_count})` : '';
    $('[data-cart-subtotal]', cartDrawer).textContent = formatMoney(cart.total_price);
    const isEmpty = cart.item_count === 0;
    empty.hidden = !isEmpty;
    items.hidden = isEmpty;
    foot.hidden = isEmpty;
    items.innerHTML = cart.items.map((item, idx) => {
      const img = item.featured_image && item.featured_image.url
        ? `<img class="line__img" src="${item.featured_image.url}${item.featured_image.url.includes('?') ? '&' : '?'}width=200" alt="" loading="lazy" width="84" height="105">`
        : '<div class="line__img"></div>';
      const variant = item.variant_title && !/default title/i.test(item.variant_title) ? `<span class="line__meta">${esc(item.variant_title)}</span>` : '';
      const sku = item.sku ? `<span class="line__meta">Code ${esc(item.sku)}</span>` : '';
      return `
        <div class="line" data-line="${idx + 1}">
          <a href="${item.url}">${img}</a>
          <div>
            <a href="${item.url}" class="line__title">${esc(item.product_title)}</a>
            ${variant}${sku}
            <div class="line__controls">
              <div class="qty qty--small">
                <button type="button" class="qty__btn" data-line-qty="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
                <span class="qty__input" aria-live="polite">${item.quantity}</span>
                <button type="button" class="qty__btn" data-line-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="line__remove" data-line-qty="0">Remove</button>
            </div>
          </div>
          <p class="line__price">${formatMoney(item.final_line_price)}</p>
        </div>`;
    }).join('');
  }

  async function refreshCart(open) {
    const cart = await getCart();
    renderCart(cart);
    if (open && useDrawer) openDrawer(cartDrawer);
    return cart;
  }

  async function changeLine(line, quantity) {
    const res = await fetch(`${routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    const cart = await res.json();
    renderCart(cart);
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-line-qty]');
      if (btn) {
        const line = parseInt(btn.closest('[data-line]').dataset.line, 10);
        changeLine(line, Math.max(0, parseInt(btn.dataset.lineQty, 10)));
      }
      if (e.target.closest('[data-drawer-close]')) closeDrawer(cartDrawer);
    });
  }

  if (useDrawer) {
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      refreshCart(true);
    }));
  }

  async function addToCart(form, button) {
    const errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    const original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }
    try {
      const res = await fetch(`${routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');
      await refreshCart(true);
      if (!useDrawer) window.location.href = routes.cart;
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      else alert(err.message);
    } finally {
      if (button) { button.disabled = false; button.innerHTML = original; }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-quick-add], [data-product-form]')) {
      e.preventDefault();
      addToCart(form, e.submitter || form.querySelector('[type="submit"]'));
    }
    if (form.matches('[data-filter-form]')) {
      // native submit works for filters; keep default
    }
  });

  /* ---------- Quantity steppers ---------- */
  $$('[data-qty]').forEach((wrap) => {
    const input = $('input', wrap);
    $('[data-qty-minus]', wrap).addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    $('[data-qty-plus]', wrap).addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- Product page: variants + gallery ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-btn]', root);
    const addLabel = $('[data-add-label]', root);
    const priceWrap = $('[data-price-wrap]', root);
    const skuEl = $('[data-sku]', root);

    function currentOptions() {
      return product.options.map((_, i) => {
        const checked = $(`input[data-option-index="${i}"]:checked`, root);
        return checked ? checked.value : null;
      });
    }

    function onChange() {
      const opts = currentOptions();
      const v = product.variants.find((variant) => variant.options.every((o, i) => o === opts[i]));
      opts.forEach((val, i) => { const label = $(`[data-option-value="${i}"]`, root); if (label) label.textContent = val; });
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (skuEl) skuEl.textContent = v.sku ? `Code ${v.sku}` : '';
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      priceWrap.innerHTML = `<div class="price price--large${onSale ? ' price--sale' : ''}">
        <span class="price__now">${formatMoney(v.price)}</span>
        ${onSale ? `<s class="price__was">${formatMoney(v.compare_at_price)}</s><span class="price__saving">You save ${formatMoney(v.compare_at_price - v.price)}</span>` : ''}
      </div>`;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, root);
        if (slide) slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    $$('input[data-option-index]', root).forEach((inp) => inp.addEventListener('change', onChange));

    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const slide = $(`[data-media-id="${t.dataset.thumb}"]`, root);
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    if (track && thumbs.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            const id = en.target.dataset.mediaId;
            thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === id));
          }
        });
      }, { root: track, threshold: [0.6] });
      $$('[data-media-id]', track).forEach((s) => io.observe(s));
    }
  });

  /* ---------- Related products ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.querySelector('.slider')) { bindSlider(el); return; }
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        bindSlider(el);
      }
    } catch (e) { /* leave empty */ }
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], [data-auto-submit]')) form.submit();
    });
    // Close other open filter panels when one opens
    $$('details.filter', form).forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) $$('details.filter', form).forEach((o) => { if (o !== d) o.open = false; });
    }));
  });
  document.addEventListener('click', (e) => {
    $$('details.filter[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });

  /* Initial count sync (cached pages) */
  if (cartDrawer) refreshCart(false).catch(() => {});
})();
